import React, { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { UserInformation } from '../UserInformation/UserInformation';
import { Text } from '../../../Text/Text';

interface UserStatementProps {
  children: ReactNode;
  className?: string;
  statementDate: Date;
  statementVisibleLines?: number;
  userAvatarUrl: string;
  userDetails: string[];
  userDetailsSeparator?: string;
  userNickName: string;
  userUrl?: string;
}

export const UserStatement = ({
  children,
  className,
  statementDate,
  userAvatarUrl,
  userDetails,
  userDetailsSeparator = ' · ',
  userNickName,
  userUrl,
}: UserStatementProps) => {
  return (
    <header className={twMerge('px-4 py-3 sm:p-4', className)}>
      <UserInformation
        avatarUrl={userAvatarUrl}
        className="mb-3"
        informationDate={statementDate}
        informationDetails={userDetails}
        informationSeparator={userDetailsSeparator}
        nickname={userNickName}
        userUrl={userUrl}
      />
      <Text className="text-trench m-0" constant variant="sm">
        {children}
      </Text>
    </header>
  );
};
